/**
 * Filtr do nowych linii
 */
angular.module('lsnBase.filters')
  .filter('unsafe', ['$sce', function($sce) {
    return function(text) {
      text = text ? (text + '') : '';
      return $sce.trustAsHtml(text.toString());
    };
  }]);